import { render, staticRenderFns } from "./OrdersRecover.vue?vue&type=template&id=f3611416&"
import script from "./OrdersRecover.vue?vue&type=script&lang=js&"
export * from "./OrdersRecover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports